if (!customElements.get('hollow-daily-countdown')) {
  customElements.define('hollow-daily-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      document.addEventListener('visibilitychange', () => this.update(), { signal: this.abort.signal });
      this.update();
    }
    update() {
      clearTimeout(this.timer);
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const remaining = Math.max(0, Math.floor((midnight - now) / 1000));
      if (this.hours) this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      if (this.minutes) this.minutes.textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      if (this.seconds) this.seconds.textContent = String(remaining % 60).padStart(2, '0');
      if (!document.hidden) this.timer = setTimeout(() => this.update(), 1000 - now.getMilliseconds());
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
  });
}

if (!customElements.get('hollow-newsletter-images')) {
  customElements.define('hollow-newsletter-images', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.images = [...this.querySelectorAll('[data-hollow-newsletter-image]')];
      this.button = this.querySelector('[data-hollow-animation-toggle]');
      this.index = Math.max(0, this.images.findIndex(image => image.classList.contains('is-active')));
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      const options = {signal:this.abort.signal};
      if (this.images.length < 2 || !this.button) return;
      this.button.hidden = false;
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.updateButton(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => {this.hovered = true; this.schedule();}, options);
      this.addEventListener('mouseleave', () => {this.hovered = false; this.schedule();}, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.isConnected && this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => {if(event.matches) this.paused = true; this.updateButton(); this.schedule();}, options);
      this.updateButton();
      this.schedule();
    }
    updateButton() {
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.setAttribute('aria-label', this.paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause);
      this.button.querySelector('[data-hollow-animation-icon]').textContent = this.paused ? '▶' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => {
        this.images[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.images.length;
        this.images[this.index].classList.add('is-active');
        this.schedule();
      }, Math.max(4000, Number(this.dataset.interval) || 4000));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
  });
}
